import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { getEvent } from '../config/events';

const EventDetails = () => {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('event') || 'youth-bootcamp';
  const event = getEvent(eventId);
  
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const eventDate = new Date(event.eventDate).getTime();
    
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = eventDate - now;
      
      if (distance < 0) {
        clearInterval(timer);
        return;
      }
      
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-5 bg-light" id="details">
      <Container>
        <h2 className="text-center mb-5 fw-bold">EVENT DETAILS</h2>
        
        <Row className="mb-5">
          <Col lg={6} className="mb-4 mb-lg-0">
            <Card className="h-100 shadow">
              <Card.Body className="p-4">
                <h3 className="fw-bold mb-4">When & Where</h3>
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <i className="bi bi-calendar-event me-2"></i>
                    <strong>Dates:</strong> {event.dates}
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-geo-alt me-2"></i>
                    <strong>Location:</strong> {event.location}
                  </li>
                </ul>
                {event.host && (
                  <p className="mb-2">
                    <i className="bi bi-person me-2"></i>
                    <strong>Host:</strong> {event.host}
                  </p>
                )}
                {event.guest && (
                  <p className="mb-2">
                    <i className="bi bi-mic me-2"></i>
                    <strong>Guest Speaker:</strong> {event.guest}
                  </p>
                )}
              </Card.Body>
            </Card>
          </Col>
          
          <Col lg={6}>
            <Card className="h-100 shadow">
              <Card.Body className="p-4 text-center">
                <h3 className="fw-bold mb-4">Countdown to {event.title}</h3>
                <Row className="countdown-timer">
                  <Col>
                    <div className="countdown-item">
                      <span className="countdown-number">{timeLeft.days}</span>
                      <span className="countdown-label">Days</span>
                    </div>
                  </Col>
                  <Col>
                    <div className="countdown-item">
                      <span className="countdown-number">{timeLeft.hours}</span>
                      <span className="countdown-label">Hours</span>
                    </div>
                  </Col>
                  <Col>
                    <div className="countdown-item">
                      <span className="countdown-number">{timeLeft.minutes}</span>
                      <span className="countdown-label">Minutes</span>
                    </div>
                  </Col>
                  <Col>
                    <div className="countdown-item">
                      <span className="countdown-number">{timeLeft.seconds}</span>
                      <span className="countdown-label">Seconds</span>
                    </div>
                  </Col>
                </Row>
                <p className="mt-4">Don't miss out - spots filling fast!</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EventDetails;